import { render, staticRenderFns } from "./secKillPage.vue?vue&type=template&id=499a216a&scoped=true&"
import script from "./secKillPage.vue?vue&type=script&lang=js&"
export * from "./secKillPage.vue?vue&type=script&lang=js&"
import style0 from "./secKillPage.vue?vue&type=style&index=0&id=499a216a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a216a",
  null
  
)

export default component.exports